// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-user-sign-in-type .emailLoginInput {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/user/user-edit/user-sign-in-type/fi-user-sign-in-type.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR","sourcesContent":[".fi-user-sign-in-type {\r\n    .emailLoginInput {\r\n        width: 100%;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
